import Helper from './Helper';
import '../assets/scss/dropdown.scss';

class Dropdown {
    /**
     * Constructor
     *
     * @param id
     */
    constructor(id) {
        // Load required assets
        import("../assets/scss/dropdown.scss");
    }

    /**
     * Load flags
     * 
     * @return {HTMLDivElement}
     */
    load(linguise_switcher)
    {
        // Get current language
        const current_lang = linguise_switcher.available_languages.find((item) => item.code === linguise_switcher.current_language);

        // Order alphabetically with default language on top
        Helper.sort(linguise_switcher);

        const language_settings = linguise_switcher.language_settings;
        const languages_lists = Helper.getOrderedLanguageList(
            linguise_switcher.available_languages, linguise_switcher.default_language, language_settings?.language_flag_order
        );

        const dropdown_elem = document.createElement('div');
        dropdown_elem.innerHTML = `
            <ul class="linguise_switcher linguise_switcher_dropdown ${language_settings?.flag_shape === 'rectangular' ? 'linguise_flag_rectangular' : 'linguise_flag_rounded'}">
                <li class="linguise_current">
                    <div class="linguise_current_lang">
                        ${Helper.renderFlag(language_settings, linguise_switcher.current_language)}
                        ${Helper.renderLanguageName(language_settings, linguise_switcher.current_language, current_lang.name, current_lang.original_name)}
                        <span class="lccaret top">
                            <svg height="48" viewBox="0 96 960 960" width="48">
                                <path d="M480 699q-6 0-11-2t-10-7L261 492q-8-8-7.5-21.5T262 449q10-10 21.5-8.5T304 450l176 176 176-176q8-8 21.5-9t21.5 9q10 8 8.5 21t-9.5 22L501 690q-5 5-10 7t-11 2Z"/>
                            </svg>
                        </span>
                    </div>
                    <ul class="linguise_switcher_sub linguise_switcher_un_mm ${linguise_switcher.available_languages.length > 9 ? 'many_languages' : ''}">
                        ${languages_lists.map(language => {
                            if (language.code !== linguise_switcher.current_language) {
                                return `<a href="${Helper.getLanguageUrl(linguise_switcher, language.code)}">
                                            <li class="linguise_lang_item" data-lang="${language.code}" id="linguise_lang_item">
                                                ${Helper.renderFlag(language_settings, language.code)}
                                                ${Helper.renderLanguageName(language_settings, language.code, language.name, language.original_name, true)}
                                            </li>
                                        </a>`
                            }
                        }).join('')}
                    </ul>
                </li>
            </ul>`;
        dropdown_elem.id = 'dropdown';

        // Replace Linguise shortcode ([linguise]) to switcher
        Helper.replaceLinguiseShortcodeToSwitcher(language_settings?.position ?? 'bottom_right', dropdown_elem, linguise_switcher);

        this.postLoad(linguise_switcher);
        return dropdown_elem;
    }

    /**
     * A post-load handler, usually used for workarounds
     */
    postLoad(linguise_switcher) {
        // Workaround for metis menu in Joomla
        const baseWrapperClass = `linguise_switcher_sub linguise_switcher_un_mm ${linguise_switcher.available_languages.length > 9 ? 'many_languages' : ''}`;
        const dropdown_wrapper = document.querySelectorAll('.linguise_switcher_un_mm');
        Array.from(dropdown_wrapper).forEach((element) => {
            if (element.__observer) {
                // already observed
                return;
            }

            const observer = new MutationObserver((mutationList) => {
                // change in attributes (class)
                mutationList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const totalValidClass = [
                            element.classList.contains('linguise_switcher_un_mm'),
                            element.classList.contains('linguise_switcher_sub'),
                            element.classList.contains('many_languages'),
                        ].filter(Boolean).length;

                        if (totalValidClass.length !== element.classList.length) {
                            // there's a difference, do something
                            element.className = baseWrapperClass;
                            // stop observing
                            observer.disconnect();
                            // detach from element
                            element.__observer = null;
                        }
                    }
                });
            });

            element.__observer = observer;

            observer.observe(element, { attributes: true, attributeFilter: ['class'] });
        });
    }
}

export default Dropdown;
